import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import PostActions from 'components/FeedList/Post/PostActions';
import { userShape, wallPostShape } from 'utils/shapes';
import ACC from './WallNotification_Aruba-Picture.png';
import ASP from './WallNotification_Aruba-Picture.png';
import CCC from './WallNotification_Curacao-Picture.png';
import MCC from './WallNotification_MCC-Picture.png';
import WCA from './WallNotification_Atmore-Picture.png';
import WCB from './WallNotification_Bethlehem-Picture.png';
import WCI from './WallNotification_Chicago-Picture.png';
import WCM from './WallNotification_Montgomery-Picture.png';
import WCW from './WallNotification_Wetumpka-Picture.png';
import './Jackpot.css';

class Jackpot extends PureComponent {
  propertyName(casinoID) {
    switch (casinoID) {
      case 'MCC':
        return 'Magic City';
      case 'WCA':
        return 'Atmore';
      case 'WCM':
        return 'Montgomery';
      case 'WCW':
        return 'Wetumpka';
      case 'WCB':
        return 'Bethlehem';
      case 'ACC':
      case 'ASP':
        return 'Aruba';
      case 'CCC':
        return 'Curacao';
      case 'WCI':
        return 'Chicago';
      default:
        return '';
    }
  }

  imageForProperty(casinoID) {
    switch (casinoID) {
      case 'MCC':
        return MCC;
      case 'WCM':
        return WCM;
      case 'WCW':
        return WCW;
      case 'WCB':
        return WCB;
      case 'ACC':
        return ACC;
      case 'ASP':
        return ASP;
      case 'CCC':
        return CCC;
      case 'WCA':
      case 'WCI':
        return WCI;
      default:
        return WCA;
    }
  }

  render() {
    const { showLegacyFeed, post, user, onDeletePost } = this.props;
    const jackpotJson = JSON.parse(post.message);
    const propertyName = this.propertyName(jackpotJson.casinoID);
    const feedJackpotClassName = showLegacyFeed
      ? 'legacy-feed-jackpot'
      : 'feed-jackpot';

    return (
      <div className={feedJackpotClassName}>
        <div className="jackpot-property">
          <img
            className="jackpot-property-image"
            src={this.imageForProperty(jackpotJson.casinoID)}
            alt={propertyName}
          />
          <div className="message-body">
            <div className="header">{propertyName} Winning Moment!</div>
            <div className="jackpot">
              {'$' + Math.ceil(jackpotJson.jackpotAmount).toLocaleString()}{' '}
              Jackpot
            </div>
            <div className="datetime">
              {moment
                .utc(jackpotJson.hitDatetime, 'YYYY-MM-DD HH:mm:ss Z')
                .tz(moment.tz.guess())
                .format('h:mm A, M/D/YY')}
            </div>
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          onDeletePost={onDeletePost}
          trashIconSize={'small'}
        />
      </div>
    );
  }
}

Jackpot.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func,
  showLegacyFeed: PropTypes.bool
};

export default Jackpot;
